import React, { useState } from "react";
import { useModal } from "../../../../../../contexts/modalContext/modalContext.js";
import Button from "../../../../..//Elements/Button/Button.js";
import { useContent } from "../../../../../../contexts/contentContext/contentContext.js";
import apiRequest from "../../../../../../utils/ApiRequest/apiRequest.js";
import { useToasts } from "react-toast-notifications";
import config from "config";
import { useUser } from "../../../../../../contexts/userContext/userContext.js";
import ToastHtmlComponent from "../../../../../Reusable/ToastHtmlComponent/ToastHtmlComponent.js";

const ChangeUserEmailModal = ({
  userData,
  newBody,
  setEmailAddress,
  userDetails,
}) => {
  const { setUserData } = useUser();
  const { closeModal } = useModal();
  const { getTextByKey } = useContent();
  const { addToast } = useToasts();
  const [password, setPassword] = useState("");
  //check password validation to change mail
  const checkUserPassword = async () => {
    const parameters = {
      password: password,
    };
    const response = await apiRequest("Users", "CheckUserPassword", parameters);
    if (response.status === "success") {
      if (response.data === 6) {
        addToast(getTextByKey("profileuserdetails-Wrong-password"), {
          appearance: "error",
        });
      }
      if (response.data === 0) {
        updateUser(newBody);
      }
      closeModal();
    }
  };

  //update user details
  const updateUser = async (body) => {
    const response = await apiRequest(
      "Users",
      "ReactUpdateUserDetailes",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data.IsSuccess) {
        setUserData(body);
        addToast(getTextByKey("update-details-success"), {
          appearance: "success",
        });
      } else {
        if (response.data.IsChangedEmail) {
          addToast(getTextByKey("profileuserdetails-email-taken"), {
            appearance: "error",
          });
        } else {
          let errText = getTextByKey("api-error");
          errText = errText.replace("#ERRORNUM#", 765346);
          errText = errText.replace("#SYSMAIL#", "contact-us");
          errText = errText.replace("#SYSMAIL#", config.supportmail);
          errText = errText.replace("#SYSMAIL#", "contact-us");
          addToast(<ToastHtmlComponent htmlStr={errText} />, {
            appearance: "error",
          });
        }
      }
    } else {
      let errText = getTextByKey("api-error");
      errText = errText.replace("#ERRORNUM#", 765346);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      errText = errText.replace("#SYSMAIL#", config.supportmail);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      addToast(<ToastHtmlComponent htmlStr={errText} />, {
        appearance: "error",
      });
    }
    return response;
  };

  return (
    <div className="change-usermail-modal">
      <div className="top-section">
        <div className="modal-content">
          <div className="modal-body">
            <div>
              <p>
                {getTextByKey("profileuserdetails-change-email-verification")}
              </p>
              <div className="passwordInput">
                <form autocomplete="off">
                  <input
                    autocomplete="new-password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder={getTextByKey(
                      "profileuserdetails-current-password"
                    )}
                  />
                </form>
              </div>
            </div>
            <div className="actions">
              <Button
                buttonClass="cancel-button"
                blank
                onClick={() => {
                  setEmailAddress(userDetails.UserName);
                  closeModal();
                }}
              >
                {getTextByKey("cancel")}
              </Button>
              <Button
                buttonClass="ok-button"
                onClick={() => {
                  checkUserPassword();
                }}
              >
                {getTextByKey(
                  "profileuserdetails-change-email-verification-ok"
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-section"></div>
    </div>
  );
};

export default ChangeUserEmailModal;
